import { Box } from "@mui/material";
import Lion from "./lion.png";
import { colors as color } from "../../css components/Style";
import { useAxios } from "../../../hooks";

const polarToCartesian = (cx, cy, r, angleDeg) => {
  const rad = (angleDeg * Math.PI) / 180;
  return {
    x: cx + r * Math.cos(rad),
    y: cy + r * Math.sin(rad),
  };
};

const describeArc = (cx, cy, r, startAngle, endAngle) => {
  const start = polarToCartesian(cx, cy, r, startAngle);
  const end = polarToCartesian(cx, cy, r, endAngle);
  const largeArc = endAngle - startAngle > 180 ? 1 : 0;

  return [
    `M ${cx} ${cy}`,
    `L ${start.x} ${start.y}`,
    `A ${r} ${r} 0 ${largeArc} 1 ${end.x} ${end.y}`,
    "Z",
  ].join(" ");
};

export default function HalfDial({
  activeIndexes,
  setActiveIndexes,
  segments,
  setIncludedSegments,
  editState,
  state,
  dispatch,
}) {
  const cx = 320;
  const cy = 320;
  const baseRadius = 300;
  const innerRadius = baseRadius - 140;
  const axios = useAxios();

  const colors = [
    color.growthOSLightBlue,
    color.growthOSLightBlue,
    color.growthOSLightBlue,
    color.growthOSLightBlue,
  ];
  const activeColors = ["#8a20ae", "#27a9af", "#f29524", "#ef5350"];

  const handleToggle = (index, segments) => {
    if (editState) {
      setIncludedSegments((prev) => {
        let segment = [...prev];
        if (
          segment.findIndex(
            (s) => parseInt(s.segmentID) === parseInt(segments.id)
          ) !== -1
        ) {
          segment = segment.filter((i) => i.segmentID !== segments.id);
          axios({
            url: "/segment/fields/" + segments.id,
            disableRedirect: true,
          }).then((res) => {
            if (res.status) {
              var segmentKey = res.data;
              let fields = { ...state };

              Object.keys(fields).map((key) => {
                if (segmentKey.includes(key)) {
                  delete fields[key];
                }
              });
              dispatch({
                type: "DELETE_SEGMENT",
                payload: { value: fields },
              });
            }
          });
        } else {
          segment.push({
            segmentID: segments.id,
            segmentTitle: segments.segment_title,
          });
        }

        return segment;
      });

      setActiveIndexes((prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index)
          : [...prev, index]
      );
    }
  };

  function getActiveElement(index) {
    if (segments[index]?.segment_title === "Content") {
      return "none";
    }
    if (!editState) {
      return "none";
    }
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
      <svg width="640" height="310">
        {[...Array(3)].map((_, index) => {
          const segmentAngle = 60;
          const startAngle = 180 + index * segmentAngle;
          const endAngle = 180 + (index + 1) * segmentAngle;
          const isActive = activeIndexes.includes(index);
          const radius = isActive ? baseRadius + 18 : baseRadius;
          const inner = radius - 140;
          const path = describeArc(cx, cy, radius, startAngle, endAngle);
          const labelAngle = (startAngle + endAngle) / 2;
          const baseLabelPos = polarToCartesian(
            cx,
            cy,
            radius - 80,
            labelAngle
          );
          // Right edge path
          const outerEnd = polarToCartesian(cx, cy, radius, endAngle);
          const innerEnd = polarToCartesian(cx, cy, inner, endAngle);
          const rightEdgePath = `
            M ${outerEnd.x} ${outerEnd.y}
            L ${innerEnd.x} ${innerEnd.y}
          `;

          return (
            <g key={index}>
              {/* Arc */}
              <path
                d={path}
                fill={isActive ? activeColors[index] : colors[index]}
                style={{
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  pointerEvents: getActiveElement(index),
                }}
                onClick={() => handleToggle(index, segments[index])}
              />

              {!isActive && (
                <path
                  d={rightEdgePath}
                  stroke={color.publicisBlue}
                  strokeWidth={2}
                />
              )}

              <text
                x={baseLabelPos.x}
                y={baseLabelPos.y - 30}
                fill={isActive ? "#fff" : color.publicisBlue}
                fontSize="14"
                fontWeight="bold"
                textAnchor="middle"
                cursor={"pointer"}
                style={{
                  pointerEvents: getActiveElement(index),
                }}
                onClick={() => handleToggle(index, segments[index])}
              >
                {segments[index]?.segment_title}
              </text>

              {segments[index]?.segment_desc?.map((line, i) => (
                <text
                  key={i}
                  x={baseLabelPos.x}
                  y={baseLabelPos.y - 10 + i * 16}
                  fill={isActive ? "#fff" : color.publicisBlue}
                  fontSize="12"
                  textAnchor="middle"
                  cursor={"pointer"}
                  style={{
                    pointerEvents: getActiveElement(index),
                  }}
                  onClick={() => handleToggle(index, segments[index])}
                >
                  {line}
                </text>
              ))}
            </g>
          );
        })}

        {/* Inner circle */}
        <path d={describeArc(cx, cy, innerRadius, 180, 360)} fill={"#1048dd"} />

        {/* Center text */}
        {/* <text
          x={cx}
          y={cy - 100}
          fill="white"
          fontSize="20"
          fontWeight="bold"
          textAnchor="middle"
        >
          Identity
        </text>
        <text
          x={cx}
          y={cy - 70}
          fill="#fff"
          fontSize="16"
          fontWeight="500"
          textAnchor="middle"
        >
          590M+ Indian Unique IDs
        </text>
        <text x={cx} y={cy - 40} fill="#fff" fontSize="12" textAnchor="middle">
          Data-Powered Audience Precision Intelligence
        </text> */}
        <image
          href={Lion}
          x={cx - 120}
          y={cy - 171} // move image up
          width="240"
          height="180"
        />
      </svg>

      <Box
        mt={"7px"}
        width={"94%"}
        bgcolor={color.publicisBlue}
        textAlign="center"
        py={1.5}
        fontWeight="bold"
        color="#fff"
        fontSize="14px"
        padding={"10px"}
      >
        {/* 60+ Data Partners . 140+ Data Fields . 1800+ Attributes */}
      </Box>
    </Box>
  );
}
